"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isElementContainsFocus = _interopRequireDefault(require("../../helpers/isElementContainsFocus"));

var _PopoverContext = _interopRequireDefault(require("../../PopoverContext"));

var _Popover = require("../../Popover.styles");

var _Content = require("./Content.styles");

var propTypes = {
  children: _propTypes["default"].node,

  /** Callback to indicate the element loses focus */
  onBlur: _propTypes["default"].func
};
var defaultProps = {
  children: null,
  onBlur: function onBlur() {}
};

var Content = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      children = props.children,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onBlur", "children"]);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      portalElement = _React$useContext.portalElement,
      refContent = _React$useContext.refContent; // TODO: extract this to Storybook story somehow so supporting numbers as strings is not required


  function isNumber(n) {
    return RegExp(/^[0-9]+$/).test(n);
  }

  function handleMouseEvent(event) {
    if (!isEager) return;

    if (event.type === "mouseover") {
      onDelayedOpen();
    } else if (event.type === "mouseout") {
      onDelayedClose();
    }
  }

  function handleBlur(event) {
    // onblur canceling onclick the following happens when:
    // Clicking twice the trigger button (open, close), will fire an onclick and onblur event
    // creating a race condition nullyfing the onClick and keeping the popover open
    // https://stackoverflow.com/questions/121499/when-a-blur-event-occurs-how-can-i-find-out-which-element-focus-went-to
    // the previous link answer suggested the use of the mouseDown event, thought, that will kill all accessibility of onClick,
    // as well will affect the devUX when you want to have a controlled Popover forcing the use of mouseDown event instead of onClick
    // Solution https://stackoverflow.com/a/121708/196038
    // Use timeout to delay examination of activeElement until after blur/focus
    // events have been processed.
    var currentTarget = event.currentTarget;
    setTimeout(function () {
      if (!(0, _isElementContainsFocus["default"])(currentTarget)) {
        onClose();
        onBlur();
      }
    }, (0, _parseInt2["default"])(_Popover.consts.transition, 10));
  }

  function cssValue(value) {
    return isNumber(value) ? "".concat(value, "px") : value;
  }

  var handleRef = function handleRef(_ref) {
    refContent(_ref);

    if (ref) {
      // https://github.com/reactjs/rfcs/blob/master/text/0017-new-create-ref.md#basic-example
      ref.current = _ref; // eslint-disable-line
    }
  };

  var contentStyles = {
    left: content.x,
    top: content.y,
    maxWidth: cssValue(content.maxWidth),
    minWidth: cssValue(content.minWidth)
  };

  if (content.width && content.width !== "auto") {
    contentStyles.width = content.width;
  }
  /* eslint-disable jsx-a11y/mouse-events-have-key-events */


  var ContentStyledComponent = /*#__PURE__*/_react["default"].createElement(_Content.ContentStyled, (0, _extends2["default"])({
    "aria-hidden": !isOpen,
    "data-component-name": "PopoverContent",
    "data-pka-anchor": "popover.content",
    ref: handleRef,
    id: content.ariaId,
    isOpen: isOpen,
    onBlur: handleBlur,
    onMouseOut: handleMouseEvent,
    onMouseOver: handleMouseEvent,
    style: contentStyles,
    tabIndex: "-1",
    zIndex: content.zIndex
  }, moreProps), props.children);

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(ContentStyledComponent, portalElement);
  }

  return ContentStyledComponent;
});
/* eslint-enable jsx-a11y/mouse-events-have-key-events */


Content.displayName = "Popover.Content";
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map